import { ISchemeToken } from './scheme-token.interface';

export interface ITokenScope {
  tokenScopeUid: string;
  createdDate: string;
  modifiedDate: string;
  version: number;
  status: string;
  name: string;
  tokenFormat: string;
  tokenType: string;
  schemeToken?: ISchemeToken;
  tokenLength: number;
  prefixLengthFromCard: number;
  suffixLengthFromCard: number;
  fixedPrefixStr: string;
  fixedSuffixStr: string;
  defaultTokenExpirationInDays: number;
  fixedPrefix?: number;
  fixedSuffix?: number;
}
